import { createContext, useContext } from "react";
import { SignInResponse } from "../BrandAuthContext/context";
import { BrandUser } from "@/types/brand";

export type UserRole = "AFFILIATE" | "BRAND" | "ADMIN" | "AGENCY";

export interface User {
  id: string;
  firstName?: string;
  lastName?: string;
  name?: string; // For brands
  email: string;
  role: UserRole;
  shop?: string; // For brands
  isActive?: boolean;
  createdAt?: string; // For tour logic
}

interface BrandAuthContextType {
  user: BrandUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (data: SignInResponse) => void;
  logout: () => void;
  version: number;
  authToken: string | null;
}

const defaultBrandAuthContextValue: BrandAuthContextType = {
  user: null,
  isAuthenticated: false,
  isLoading: true,
  login: () => {},
  logout: () => {},
  version: 0,
  authToken: null,
};
export interface AuthContextType {
  brandAuth: BrandAuthContextType;
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  authToken: string | null;
  login: (data: { user: User; token: string }) => void;
  logout: () => void;
}

const defaultContextValue: AuthContextType = {
  brandAuth: defaultBrandAuthContextValue,
  user: null,
  isAuthenticated: false,
  isLoading: true,
  authToken: null,
  login: () => {},
  logout: () => {},
};

export const AuthContext = createContext<AuthContextType>(defaultContextValue);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
